import GovernmentPortal from '../images/partner_logo/Uz_Res_Hukumat_Portali.webp';
import myGovUz from '../images/partner_logo/Yagona_portal.svg';
import neftgaz from '../images/partner_logo/Neftgaz.png';
import OzResEnergy from '../images/partner_logo/Uz_Res_Energetika_Vazirligi.png';
import OzResBuilding from '../images/partner_logo/Qurulish_va_uy-joy_kommunal_xujaligi_vazirligi.png';
import MinistryEmergy from '../images/partner_logo/Favqulodda_vaziyat_vazirligi.webp';
export const UsefulResourcesData = [
    {
        logo: GovernmentPortal,
        name_oz: "O'ZBEKISTON RESPUBLIKASI HUKUMAT PORTALI",
        name_uz: "ЎЗБEКИСТОН РEСПУБЛИКАСИ ҲУКУМАТ ПОРТАЛИ",
        name_ru: "ПРАВИТЕЛЬСТВЕННЫЙ ПОРТАЛ РЕСПУБЛИКИ УЗБЕКИСТАН",
        name_en: "GOVERNMENT PORTAL OF THE REPUBLIC OF UZBEKISTAN",
        link_oz: "https://gov.uz/",
        link_uz: "https://gov.uz/",
        link_ru: "https://gov.uz/ru/",
        link_en: "https://gov.uz/en/",
        id: 1
    },
    {
        logo: myGovUz,
        name_oz: "Yagona interaktiv davlat xizmatlari portali",
        name_uz: "Ягона интерактив давлат хизматлари портали",
        name_ru: "Единый портал интерактивных государственных услуг",
        name_en: "Public services for foreign citizens",
        link_oz: "https://my.gov.uz/oz",
        link_uz: "https://my.gov.uz/uz",
        link_ru: "https://my.gov.uz/ru",
        link_en: "https://my.gov.uz/en/tourism/index",
        id: 2
    },
    {
        logo: neftgaz,
        name_oz: "«Ўзбекнефтгаз» AJ",
        name_uz: "«Ўзбекнефтгаз» АЖ",
        name_ru: "АО «Ўзбекнефтгаз»",
        name_en: "«Ўзбекнефтгаз» JSC",
        link_oz: "https://www.ung.uz/",
        link_uz: "https://www.ung.uz/",
        link_ru: "https://www.ung.uz/",
        link_en: "https://www.ung.uz/",
        id: 3
    },
    {
        logo: OzResEnergy,
        name_oz: "O‘ZBEKISTON RESPUBLIKASI ENERGETIKA VAZIRLIGI",
        name_uz: "ЎЗБEКИСТОН РEСПУБЛИКАСИ ЭНЕРГEТИКА ВАЗИРЛИГИ",
        name_ru: "МИНИСТЕРСТВО ЭНЕРГЕТИКИ РЕСПУБЛИКИ УЗБЕКИСТАН",
        name_en: "MINISTRY OF ENERGY OF THE REPUBLIC OF UZBEKISTAN",
        link_oz: "https://minenergy.uz/uz",
        link_uz: "https://minenergy.uz/uz",
        link_ru: "https://minenergy.uz/ru",
        link_en: "https://minenergy.uz/en",
        id: 4
    },
    {
        logo: OzResBuilding,
        name_oz: "O‘ZBЕKISTON RЕSPUBLIKASI QURILISH VA UY-JOY KOMMUNAL XO‘JALIGI VAZIRLIGI",
        name_uz: "ЎЗБЕКИСТОН РЕСПУБЛИКАСИ ҚУРИЛИШ ВА УЙ-ЖОЙ КОММУНАЛ ХЎЖАЛИГИ ВАЗИРЛИГИ",
        name_ru: "МИНИСТЕРСТВО СТРОИТЕЛЬСТВА И ЖИЛИЩНО-КОММУНАЛЬНОГО ХОЗЯЙСТВА РЕСПУБЛИКИ УЗБЕКИСТАН",
        name_en: "МИНИСТЕРСТВО СТРОИТЕЛЬСТВА И ЖИЛИЩНО-КОММУНАЛЬНОГО ХОЗЯЙСТВА РЕСПУБЛИКИ УЗБЕКИСТАН",
        link_oz: "https://mc.uz/oz",
        link_uz: "https://mc.uz/uz",
        link_ru: "https://mc.uz/ru",
        link_en: "https://mc.uz/ru",
        id: 5
    },
    {
        logo: MinistryEmergy,
        name_oz: "O‘ZBЕKISTОN RЕSPUBLIKАSI FAVQULODDA VAZIYATLAR VAZIRLIGI",
        name_uz: "ЎЗБЕКИСТОН РЕСПУБЛИКАСИ ФАВҚУЛОДДА ВАЗИЯТЛАР ВАЗИРЛИГИ",
        name_ru: "МИНИСТЕРСТВО ПО ЧРЕЗВЫЧАЙНЫМ СИТУАЦИЯМ РЕСПУБЛИКИ УЗБЕКИСТАН",
        name_en: "MINISTRY OF EMERGENCY SITUATIONS OF THE REPUBLIC OF UZBEKISTAN",
        link_oz: "https://gov.uz/fvv/sections/aholini-favqulodda-vaziyatlarda-togri-harakat-qilishga-orgatuvchi-foydali-havolalar/",
        link_uz: "https://gov.uz/fvv/sections/aholini-favqulodda-vaziyatlarda-togri-harakat-qilishga-orgatuvchi-foydali-havolalar/",
        link_ru: "https://gov.uz/ru/fvv/sections/aholini-favqulodda-vaziyatlarda-togri-harakat-qilishga-orgatuvchi-foydali-havolalar/",
        link_en: "https://gov.uz/en/fvv/sections/aholini-favqulodda-vaziyatlarda-togri-harakat-qilishga-orgatuvchi-foydali-havolalar/",
        id: 6
    },
]